import Vue from "vue";
import VueRouter from "vue-router";
import VueGtag from "vue-gtag";

import Portada from "../views/Portada.vue";
const InmueblesList = () =>
  import(
    /* webpackChunkName: "app-views-nohome" */ "../views/InmueblesList.vue"
  );
const InmueblesDetail = () =>
  import(
    /* webpackChunkName: "app-views-nohome" */ "../views/InmueblesDetail.vue"
  );

Vue.use(VueRouter);

Vue.use(VueGtag, {
  config: { id: "G-DKLR5HKDGQ" }
  // lo quitamos porque si el usuario no quiere lo desactiva en el navegador
  // bootstrap: false
});

const routes = [
  {
    path: "/",
    name: "portada",
    component: Portada
  },
  {
    path: "/inmuebles",
    name: "inmuebles-list",
    component: InmueblesList,
    props: true
  },
  {
    path: "/inmuebles/:id",
    name: "inmuebles-detail",
    component: InmueblesDetail,
    props: true
  }
  // {
  //   path: "/empleados/:id",
  //   component: AppEmpleadosListView,
  //   children: [{ path: "", component: AppEmpleadosDetailView }]
  // }

  // ,
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  routes
});

router.afterEach(to => {
  try {
    var baseUrl4PageView = window.location.href.replace(
      window.location.hash ? "/" + window.location.hash : "",
      ""
    );
    var url4PageView = baseUrl4PageView + to.fullPath;

    var pageViewOptions = {
      page_title: to.name,
      page_path: to.path,
      page_location: url4PageView
    };
    Vue.$gtag.pageview(pageViewOptions);
  } catch (e) {
    // Error si no está activado, p.e. si no permite las cookies en el navegador
  }
});

export default router;
